///masterconfigitem/list/all
export const MASTER_CONFIG_ITEM_LIST = "MASTER_CONFIG_ITEM_LIST";
export const MASTER_CONFIG_ITEM_LIST_SUCCESS = "MASTER_CONFIG_ITEM_LIST_SUCCESS";
export const MASTER_CONFIG_ITEM_LIST_FAILURE = "MASTER_CONFIG_ITEM_LIST_FAILURE";
///masterconfigitem/create
export const MASTER_CONFIG_ITEM_CREATE = "MASTER_CONFIG_ITEM_CREATE";
export const MASTER_CONFIG_ITEM_CREATE_SUCCESS =
  "MASTER_CONFIG_ITEM_CREATE_SUCCESS";
export const MASTER_CONFIG_ITEM_CREATE_FAILURE =
  "MASTER_CONFIG_ITEM_CREATE_FAILURE";
///masterconfigitem/update
export const MASTER_CONFIG_ITEM_UPDATE = "MASTER_CONFIG_ITEM_UPDATE";
export const MASTER_CONFIG_ITEM_UPDATE_SUCCESS =
  "MASTER_CONFIG_ITEM_UPDATE_SUCCESS";
export const MASTER_CONFIG_ITEM_UPDATE_FAILURE =
  "MASTER_CONFIG_ITEM_UPDATE_FAILURE";
